import { z } from 'zod';
import { SanityDocumentSchema } from '../sanity';
import { ChartQuantitativeSchema } from '$lib/sanity/schemas/components/Chart';
import { ComponentType } from '$lib/sanity/types';

export const BarSchema = SanityDocumentSchema.merge(ChartQuantitativeSchema).extend({
  _type: z.literal(ComponentType.Bar),
  orientation: z
    .string()
    .nullish()
    .transform((x) => x ?? 'horizontal')
});

export type Bar = z.infer<typeof BarSchema>;
